(function($){
    $(document).ready(function(){

        $('[data-toggle="popover"]').popover();

    });
});


// WEBPACK FOOTER //
// ./src/js/app/homepage.js